import { useQuery } from '@tanstack/vue-query'
import { session } from '@/composables/useSession'
import { getFilterOptions } from '../api/filters'

export default function useFetchFilterOptions() {
  return useQuery({
    queryKey: ['filter-options', session.workspace.id],
    queryFn: () => getFilterOptions().then(({ data }) => data),
    staleTime: Infinity,
  })
}
